import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import Session, { DaySlot, TimeSlot } from "../components/timetableSession";
import schedule from "../data/kids_schedule";
import { isNewDay, parseDateString } from "../tools/utils";

const Wrapper = styled.div`
  width: 100%;

  @media screen and (min-width: 1050px) {
    display: grid;
    width: 320px;
    grid-template-rows:
      [days] auto
      [time-930] auto
      [time-1000] auto
      [time-1030] auto
      [time-1050] auto
      [time-1100] auto
      [time-1130] auto
      [time-1150] auto
      [time-1215] auto
      [time-1245] auto;

    grid-template-columns:
      [times] 48px
      [saturday-start] auto
      [saturday-end saturday-overlap-start] auto
      [saturday-overlap-end saturday-overlap-2-start];
      [saturday-overlap-2-end];
  }
`;

const table = (props) => {
  let data = schedule.map((slot) => {
    let lessons = slot.lessons.map((lesson) => {
      let slug = lesson.title.split(" ").splice(0, 2).join("-").toLowerCase();
      let loc = lesson.place.split(" ").join("-").toLowerCase();
      return { ...lesson, slug, loc };
    });
    return { ...slot, lessons };
  });

  return (
    <>
      <Wrapper>
        <TimeSlot
          css={css`
            grid-row: time-930;
          `}
        >
          9:30am
        </TimeSlot>
        <TimeSlot
          css={css`
            grid-row: time-1000;
          `}
        >
          10:00am
        </TimeSlot>
        <TimeSlot
          css={css`
            grid-row: time-1030;
          `}
        >
          10:30am
        </TimeSlot>
        <TimeSlot
          css={css`
            grid-row: time-1050;
          `}
        >
          10:50am
        </TimeSlot>
        <TimeSlot
          css={css`
            grid-row: time-1100;
          `}
        >
          11:00am
        </TimeSlot>
        <TimeSlot
          css={css`
            grid-row: time-1130;
          `}
        >
          11:30am
        </TimeSlot>
        <TimeSlot
          css={css`
            grid-row: time-1150;
          `}
        >
          11:50am
        </TimeSlot>

        {data.map((slot, i) => {
          return (
            <React.Fragment key={i}>
              {isNewDay(data, i) && (
                <DaySlot
                  aria-hidden="true"
                  css={css`
                    grid-column: ${slot.day.toLowerCase() + "/ span 2"};
                    grid-row: days;
                  `}
                >
                  {slot.day + "s"}
                </DaySlot>
              )}
              <div
                css={css`
                  grid-column: ${slot.day.toLowerCase()};
                  grid-row: ${"time-" + slot.startTime} /
                    ${"time-" + slot.endTime};
                  display: flex;
                  justify-content: space-between;
                  padding: 0.2rem;
                  perspective: 100px;

                  a + a {
                    margin-left: 0.2rem;
                  }
                `}
              >
                {slot.lessons.map((lesson, i) => {
                  if (
                    (lesson.type === "kids") &
                    !parseDateString(lesson.endDate).isPastDate()
                  )
                    return (
                      <Session
                        key={i}
                        className={`${lesson.loc} slot`}
                        css={css`
                          flex: 0 1 100%;
                        `}
                        title={lesson.title}
                        startTime={slot.startTime}
                        endTime={slot.endTime}
                        location={lesson.place}
                        startDate={lesson.startDate}
                        path={lesson.loc}
                      />
                    );
                  return null;
                })}
              </div>
            </React.Fragment>
          );
        })}
      </Wrapper>
    </>
  );
};

export default table;
